/**
 * Wave 29 Chunk 8 — Inline holiday banner.
 *
 * Drops a small alert under a date input when the picked date is a SA
 * public holiday. Zero layout cost when it doesn't apply.
 */
import { useHolidays } from "../lib/holidays";

export default function HolidayWarning({ dateIso, label = "Heads up" }) {
  const { isHoliday } = useHolidays();
  const h = isHoliday(dateIso);
  if (!h) return null;
  return (
    <div
      className="mt-1 text-[10px] text-amber-300 inline-flex items-center gap-1"
      data-testid={`holiday-warning-${dateIso}`}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-amber-300" />
      {label}: <strong>{h.name}</strong> — public holiday in South Africa.
    </div>
  );
}
